import { adaptBehavior } from '~/services/origins/contentful/adapters/adaptBehavior';
import { adaptFeedback } from '~/services/origins/contentful/adapters/adaptFeedback';
import { adaptSteps } from '~/services/origins/contentful/adapters/adaptSteps';
import type { ContentfulForm } from '~/services/origins/contentful';
import type { FormSchema } from '~/shared/domain/models';

export const adaptContentfulFormToFormSchema = (data: ContentfulForm): FormSchema => {
  if (!data?.fields) {
    throw new Error('Missing form params');
  }

  const { fields } = data;

  return {
    type: fields.type,
    product: fields.product,
    behavior: adaptBehavior(fields.behavior),
    feedback: adaptFeedback({
      feedbackTitle: fields.feedbackTitle,
      feedbackSubtitle: fields.feedbackSubtitle,
    }),
    components: adaptSteps(fields.steps),
  };
};
